import moment from 'moment-timezone'

export const formatJobId = (id) => `EJW${id + 1000}`
export const toMysqlTime = (d) => moment(d).tz('Europe/London').format('YYYY-MM-DD HH:mm:ss')